'use strict';

var jsforce = require('../core');
jsforce.browser = require('./client');
require('../api');
module.exports = jsforce;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsforce/lib/browser/jsforce.js
// module id = rudk
// module chunks = 0